import { lazy } from 'react';

export const ChallengePlayerRemoveForm = lazy(
  () => import('./ChallengePlayerRemoveForm'),
);
